export enum PartnerGroupRules {
  AccessToPresoldMemberships = 'access_to_pre_sold_memberships',
  AccessToCustomSLA = 'access_to_custom_sla',
  AccessToSubscriptionManagement = 'access_to_subscription_management',
  AccessToSubscriptionManagementPlus = 'access_to_subscription_management_plus',
  AccessToProvisionProjects = 'access_to_provision_projects',
  AccessToSlaStipeSync = 'access_to_sla_stipe_sync',
  AccessToUserMentionsInConversationMessages = 'access_to_user_mentions_in_conversation_messages',
  AccessToGroupMentionsInConversationMessages = 'access_to_group_mentions_in_conversation_messages',
  AccessToSlaStripeSync = 'access_to_sla_stripe_sync',
  AccessToAutofillSiteDocumentation = 'access_to_autofill_site_documentation',
  AccessToAiSiteSummary = 'access_to_ai_site_summary',
  ProvisionSignal = 'provision_signal',
  PreventChargeClientsPreLITS = 'prevent_charge_clients_prelits',
  AccessToProvisionSidekick = 'access_to_provision_sidekick',
  AccessToManageProvisionWorkflows = 'access_to_manage_provision_workflows',
  AccessToSecurityOnlySla = 'access_to_security_only_sla',
  UsesNewEscalationPolicies = 'uses_new_escalation_policies',
  AccessToOnevisionBpo = 'access_to_onevision_bpo',
  AccessToPlatformCustomViews = 'access_to_platform_custom_views',
  AccessToPlatformBehaviors = 'access_to_platform_behaviors',
  AccessToPlatformMacros = 'access_to_platform_macros',
  AccessToPlatformSLAs = 'access_to_platform_slas',
  AccessToPlatformCustomAttributes = 'access_to_platform_custom_attributes',
  AccessToPlatformAssigneeGroups = 'access_to_platform_assignee_groups',
  AccessToPlatformUserGroups = 'access_to_platform_user_groups',
  AccessToViewPartnerInvoices = 'access_to_view_partner_invoices',
  SmsSessionsAvailable = 'sms_sessions_available',
  AccessToOneTimeMembershipActivationPilot = 'access_to_one_time_membership_activation_pilot',
}

export enum UserGroupRules {
  ExportData = 'export_data',
  Reports = 'reports',
  Admin = 'admin',
  SuperAdmin = 'super_admin',
  ProvisionSignal = 'provision_signal',
  AvailablePartnerIds = 'available_partner_ids',
  AccessToDataImport = 'access_to_data_import',
  AccessToPrivateUserGrups = 'access_to_private_user_grups',
  AccessToBilling = 'access_to_billing',
  AccessToViewPartnerInvoices = 'access_to_view_partner_invoices',
  AccessToViewConversations = 'access_to_view_conversations',
  AccessToChangeConversationStatus = 'access_to_change_conversation_status',
  AccessToPartnerTab = 'access_to_partner_tab',
  AccessToEditPartnerTab = 'access_to_edit_partner_tab',
  AccessToUpdateSiteDocumentation = 'access_to_update_site_documentation',
  AccessToManageLabels = 'access_to_manage_labels',
  AccessToManageCustomAttributes = 'access_to_manage_custom_attributes',
  AccessToViewCustomAttributes = 'access_to_view_custom_attributes',
  AccessToPrivateLabels = 'access_to_private_labels',
  CanUpdateSLAs = 'can_update_sla',
  AccessToUpdateConversation = 'access_to_update_conversations',
  AccessToUpdateConversationStatus = 'access_to_update_conversation_status',
  AccessToUpdateConversationUrgency = 'access_to_update_conversation_urgency',
  AccessToUpdateAllConversationStatuses = 'access_to_update_all_conversation_statuses',
  AccessToManageChannelSettings = 'access_to_manage_channel_settings',
  AccessToManageClientSegments = 'access_to_manage_client_segments',
  AccessToManageBusinessHours = 'access_to_manage_business_hours',
  AccessToManageMacros = 'access_to_manage_macros',
  AccessToRulesEngine = 'access_to_rules_engine',
  AbilityToRemoveMacroActions = 'ability_to_remove_macro_actions',
  AccessToDeleteConversations = 'access_to_delete_conversations',
  AccessToSettingsPreferences = 'access_to_settings_preferences',
  AccessToUserManagementV2 = 'access_to_user_management_v2',
  AccessToCreateNewPartner = 'access_to_create_new_partner',
  AccessToSendExternalConversationMessages = 'access_to_send_external_conversation_messages',
  AccessToUpdatePrivateGroups = 'can_update_private_user_groups',
  AccessToUpdateAssigneeGroups = 'access_to_update_assignee_groups',
  AccessToManageAssigneeGroups = 'access_to_manage_assignee_groups',
  AccessToManagePublicFolders = 'can_manage_public_view_folders',
  AccessToManageBlockedContacts = 'access_to_manage_blocked_contacts',
  AccessToManageEscalationSettings = 'access_to_manage_escalation_settings',
  AccessToDownloadCallRecordings = 'access_to_download_call_recordings',
  AccessToAiConversationSummary = 'access_to_ai_conversation_summary',
  AccessToAiSiteSummary = 'access_to_ai_site_summary',
  AccessToTabsInProvision = 'access_to_tabs_in_provision',
  AccessToNotificationPreferences = 'access_to_notification_preferences',
  AccessToMergeSites = 'access_to_merge_sites',
  AccessToInbox = 'access_to_in_app_inbox',
  AccessToSignalV2 = 'access_to_signal_v2',
  AiAssistant = 'ai_assistant',
  AccessToChangeProjectStatus = 'access_to_change_project_status',
  AccessToHolidaysSchedule = 'access_to_holidays_schedule',
  AccessToSupportPoliciesInAssistant = 'access_to_support_policies_in_assistant',
  AccessToManageSupportPoliciesInAssistant = 'access_to_manage_support_policies_in_assistant',
  AccessToViewSignalIncidentInConversation = 'access_to_view_signal_incident_in_conversation',
  AccessToResolveSignalIncident = 'access_to_resolve_signal_incident',
  AccessToViewTriageIntelligence = 'access_to_view_triage_intelligence',
  AccessToNewEscalationPolicyManagement = 'access_to_new_escalation_policy_management',
  AccessToActivityFeedInConversations = 'access_to_activity_feed_in_conversations',
  AccessToActivityFeedInSites = 'access_to_activity_feed_in_sites',
  AccessToActivityFeedInClients = 'access_to_activity_feed_in_clients',
  AccessToAutofillSiteDocumentation = 'access_to_autofill_site_documentation',
  AccessToEditInternalNotes = 'access_to_edit_internal_notes',
  AccessToRestoreDeletedConversations = 'access_to_restore_deleted_conversations',
  AccessToPermanentlyDeleteConversations = 'access_to_permanently_delete_conversations',
  AccessToProvisionSidekick = 'access_to_provision_sidekick',
  AccessToManageProvisionWorkflows = 'access_to_manage_provision_workflows',
  AccessToSettingsIntegrations = 'access_to_settings_integrations',
  AccessToConfigureMemberships = 'access_to_configure_memberships',
  AccessToAddCustomMembershipPlan = 'access_to_add_custom_membership_plan',
  AccessToGenerateCustomCheckoutUrl = 'access_to_generate_custom_checkout_url',
  AccessToDtoolsImportTool = 'access_to_dtools_import_tool',
  AccessToPortalioImportTool = 'access_to_portalio_import_tool',
  AccessToPlatformPartner = 'access_to_platform_partner',
  AccessToSetSecurityOnlySla = 'access_to_set_security_only_sla',
  AccessToCopyConversationAsMarkdown = 'access_to_copy_conversation_as_markdown',
  AccessToFlatFileDataImport = 'access_to_flat_file_data_import',
  AccessToDtoolsDataImport = 'access_to_dtools_data_import',
  AccessToBulkEditAttributes = 'access_to_bulk_edit_attributes',
  AccessToViewMembershipsSettingsPage = 'access_to_view_memberships_settings_page',
  AccessToManageSubAssignees = 'access_to_manage_sub_assignees',
  AccessToNonBpoPartners = 'access_to_non_bpo_partners',
  AccessToPauseSubscription = 'access_to_pause_subscription',
  AccessToProvisionPublicApi = 'access_to_provision_public_api',
  AccessToDeleteAddresses = 'access_to_delete_addresses',
  AccessToRestoreDeletedAddresses = 'access_to_restore_deleted_addresses',
  AccessToManageAiSettings = 'access_to_manage_ai_settings',
  AccessToPersonalizeSidepanel = 'access_to_personalize_sidepanel',
  AccessToPolicyPreview = 'access_to_policy_preview',
  AccessToDeleteClients = 'access_to_delete_clients',
  AccessToPermanentlyDeleteClients = 'access_to_permanently_delete_clients',
  AccessToRestoreClients = 'access_to_restore_clients',
  AccessToSmsSessions = 'access_to_sms_sessions',
  AccessToManageLandingPages = 'access_to_manage_landing_pages',
  AccessToDeleteConversationAttachments = 'access_to_delete_conversation_attachments',
  HasAccessToActivateMembershipTrial = 'has_access_to_activate_membership_trial',
}

export const RuleValues = {
  True: 'true',
  False: 'false',
  All: '*',
} as const;

export type MatchType = 'all' | 'any';

export interface AllowedRuleSet {
  rules: (PartnerGroupRules | UserGroupRules)[];
  matchType?: MatchType;
}
